import { createSelector } from 'reselect'
import * as Types from 'apps/fleet-planner/types'
import { IStore } from 'apps/fleet-planner/utils/types/store'

export const recentFacilitiesStateSelector = (state: IStore): Types.IRecentFacilitiesState =>
  state.facilities

/**
 * Pass a `Facility` id as an argument to get a result
 * @example
 * const currentStopFacility = useSelector<IStore, IFacility | undefined>(state =>
 *   facilityByIdSelector(state, facilityId)
 * ))
 */
export const facilityByIdSelector = createSelector(
  recentFacilitiesStateSelector,
  (_: IStore, facilityId: string) => facilityId,
  ({ facilities = [] }: Types.IRecentFacilitiesState, facilityId: string) => {
    return facilities.find(f => `${f.id}` === `${facilityId}`)
  }
)

export const isLoading = createSelector(
  recentFacilitiesStateSelector,
  (res): boolean => !!res.fetching
)

export const selectRecentFacilities = createSelector(
  recentFacilitiesStateSelector,
  res => res.facilities
)
